import './styles.scss'

interface SydSkeletonLoadingProps {
  height?: string
  marginTop?: string
  type?: 'row' | 'form' | 'chart'
  width?: string
}

const SydSkeletonLoading = (props: SydSkeletonLoadingProps) => {
  const { type = 'row', marginTop, height, width } = props

  return (
    <div
      className={`
      syd-skeleton-loading ${type}`}
      style={{
        width: width ? width : '100%',
        marginTop: marginTop ? marginTop : undefined,
        height: height ? height : undefined,
      }}></div>
  )
}

export default SydSkeletonLoading
